import { CloseLargeIcon } from '@docnboard/icons/rc';
import { useCallback } from 'react';

import { Badge } from '../badge';
import { IconButton } from '../button';
import { chipsContent } from './style.css';

export type ItemChip = {
  id: string;
  name: string;
};

export type ChipsProps = {
  listItems: ItemChip[];
  setListItems?: (
    v: ItemChip[] | ((prev: ItemChip[] | undefined) => ItemChip[])
  ) => void;
};

export const Chips = ({ listItems, setListItems }: ChipsProps) => {
  const handleDeleteChip = useCallback(
    (id: string) => {
      setListItems?.(prev => {
        return [...(prev || [])].filter(item => item.id !== id);
      });
    },
    [setListItems]
  );

  return listItems.map(item => (
    <Badge className={chipsContent} key={item.id}>
      {item.name}
      <IconButton onClick={() => handleDeleteChip(item.id)}>
        <CloseLargeIcon />
      </IconButton>
    </Badge>
  ));
};
